// Speaking a string with a chosen SpeechSynthesisVoice.
//
// Extracted so the game and the voice picker can't drift apart on the two
// non-obvious bits: cancel() first, because queued utterances otherwise stack up
// and play one after another when you click twice; and setting utterance.lang
// explicitly, which Android needs even though the voice already carries it.

export function speak(text, voice) {
  if(!text || !voice || typeof window.speechSynthesis === 'undefined') {
    return false;
  }

  const utterance = new SpeechSynthesisUtterance(text);
  utterance.voice = voice;
  utterance.lang = voice.lang;
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(utterance);
  return true;
}

// The voices the device can offer for a language. Matched on the two-letter
// prefix so es-ES, es-MX and es_419 all count as Spanish.
export function voicesForLanguage(voices, twoLetterLanguageCode) {
  if(!voices || !twoLetterLanguageCode) {
    return [];
  }
  const regex = new RegExp('^' + twoLetterLanguageCode, 'i');
  return voices.filter((voice) => voice.lang && voice.lang.match(regex));
}
